import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyCreateEditTask = lazyWithRetry(() => import("./CreateEditTask"));

const CreateEditTask = (props: { mode: "create" | "edit" }) => (
  <LazyCreateEditTask {...props} />
);

export default CreateEditTask;
